import { Text } from 'preact-i18n';
import flexibleCalendarFlatImg from '../../../assets/images/flexible-calendar-flat.webp';
import flexibleCalendarIcon from '../../../assets/images/ic-flexible-calendar.webp';

const ReturnOpenSwitch = ({ returnIsOpen, handleToggleOpenReturn, flatVariant }) => {
  const switchIconSrc = flatVariant ? flexibleCalendarFlatImg : flexibleCalendarIcon;
  return (
    <label className="udp-open-return">
      <img src={switchIconSrc} className="udp-open-return__icon" alt="" aria-hidden="true" />
      <div className="udp-open-return__text">
        <span className="udp-open-return__title">
          <Text id="label.open_return" />
        </span>
        <span className="udp-open-return__subtitle">
          <Text id="label.open_return_subtitle" />
        </span>
      </div>
      <div
        className={`udp-open-return__switch${returnIsOpen ? ' udp-open-return__switch--on' : ''}`}
        role="switch"
        aria-checked={returnIsOpen}
        tabIndex={0}
        onClick={handleToggleOpenReturn}
        onKeyDown={e => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            handleToggleOpenReturn();
          }
        }}
      >
        <div className="udp-open-return__knob" />
      </div>
    </label>
  );
};

export default ReturnOpenSwitch;
